import F from "@mui/icons-material/KeyboardArrowDown";
import q from "@mui/icons-material/KeyboardArrowUp";
import { styled as t, Box as n, Typography as l, ButtonBase as C } from "@mui/material";
import { commaNumber as O } from "../../common-lib/utils/string.js";
import { useFrontendConfigContext as U } from "../../config-lib/contexts/FrontendConfigContext.js";
import K from "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import N from "../../temp-lib/components/share/next/Image.js";
import { DEFAULT_ANIMATE_DURATION as g } from "../../temp-lib/constants/layout.js";
import { noForwardProps as S } from "../../temp-lib/util/styled/index.js";
import V from "../../ui-lib/components/ApeironTooltip.js";
import X from "../assets/background-level-privilege-header-long.png.js";
import J from "../assets/icon-privilege-new.png.js";
import y from "./VipArrowIcon.js";
import * as a from "ramda";
import { useState as $, useCallback as f } from "react";
import { useTranslation as Q, Trans as W } from "react-i18next";
import { jsxs as o, jsx as i, Fragment as B } from "react/jsx-runtime";
const Y = 12, Z = t(n)`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  width: 100%;
  max-width: 800px;
`, ee = t(n)`
  align-items: center;
  aspect-ratio: 800/63;
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
`, te = t(N)`
  height: 100px;
  position: absolute;
  width: 100%;
  min-width: 600px;
`, ie = t(n)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 80%;
  max-width: 600px;
`, ne = t(l)`
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: 1.1;
  text-align: center;
  ${(e) => e.theme.breakpoints.up("res480")} {
    font-size: 20px;
  }
  ${(e) => e.theme.breakpoints.down("res480")} {
    font-size: 16px;
  }
`, oe = t(l)`
  color: #ff6422;
  display: block;
  font-weight: 400;
  ${(e) => e.theme.breakpoints.up("res768")} {
    font-size: 14px;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    font-size: 12px;
  }
`, re = t(n)`
  display: flex;
  position: relative;
  width: 100%;

  ${(e) => e.theme.breakpoints.up("res480")} {
    padding: 0 40px;
  }
  ${(e) => e.theme.breakpoints.down("res480")} {
    padding: 0 30px;
  }
`, ae = t(n)`
  width: 100%;
`, se = t(n, S)`
  align-items: center;
  background-color: #dadadb;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  transition: max-height ${g}ms;
  width: 100%;

  max-height: ${(e) => e.__isExpanded ? "100%" : "590px"};

  ${(e) => e.__isExpanded ? "" : `
         &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          pointer-events: none;
          background-image: linear-gradient(
            to bottom,
            #dadadb00 0%,
            #dadadbaa 40%,
            #dadadb 100%
          );
          width: 100%;
          height: 50px;
        }
      `};
`, le = t(n)`
  align-items: center;
  background-color: #405872;
  display: flex;
  justify-content: center;
  width: 100%;
`, pe = t(K)`
  &.Mui-disabled {
    opacity: 1;
  }
`, de = t(l)`
  color: #e2ac50;
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: 1.5;
  padding: 10px 20px;
  text-align: center;

  strong {
    color: #e2ac50;
    text-decoration: underline;
    text-decoration-color: #e2ac50;
  }

  ${(e) => e.theme.breakpoints.up("res480")} {
    font-size: 18px;
  }
  ${(e) => e.theme.breakpoints.down("res480")} {
    font-size: 16px;
  }
`, ce = t(n)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 14px 0px;
  width: 80%;
`, me = t(n)`
  align-items: center;
  display: flex;
  gap: 10px;

  :hover p {
    background-color: #ffffff11;
    text-shadow: 2px 12px 12px #35343499;
    transform: translateX(5px) scale(1.05);
  }
`, he = t(n)`
  --animate-bouncing-min: 1.1;
  --animate-bouncing-max: 0.95;

  animation: bouncing 1.25s infinite;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  height: 10px;
  position: relative;
  width: 10px;
`, xe = t(N)`
  aspect-ratio: 1;
  filter: contrast(1.5) saturate(1.5);
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 26px;
`, fe = t(n)`
  background-color: #546064;
  height: 10px;
  transform: rotate(45deg);
  width: 10px;
`, ge = t(l)`
  color: black;
  font-weight: 300;
  line-height: 1.5;
  margin-left: 18px;
  transition: transform ${g}ms,
    text-shadow ${g}ms;

  ${(e) => e.theme.breakpoints.up("res480")} {
    font-size: 16px;
  }
  ${(e) => e.theme.breakpoints.down("res480")} {
    font-size: 14px;
  }
`, ue = t(l)`
  color: #2a9dff;
  font-weight: 500;
  margin: 0px -15px 0 -4px;
`, ve = t(l)`
  color: #e08e00;
  font-weight: 400;
  margin: 0px 5px;
`, L = t(C)`
  ${(e) => e.theme.breakpoints.up("res768")} {
    width: 42px;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    width: 24px;
  }
`, be = L, we = t(L)`
  transform: rotate(180deg);
`, ke = t(C)`
  // ? set z-index to show in front of gradient overlay
  z-index: 1;

  border-radius: 4px;
  bottom: 16px;
  color: #3682eb;
  font-size: 16px;
  font-weight: 300;
  padding: 4px 10px;
  position: absolute;
  right: 16px;
`, He = (e) => {
  var b;
  const {
    defaultLevel: z,
    privileges: u
  } = e, {
    t: p
  } = Q(), {
    config: h
  } = U(), [d, E] = $(!1), T = f(() => {
    E(() => !d);
  }, [d]), [r, v] = $(Math.max(1, z)), A = Math.max(0, r - 1), c = u[A], m = a.length(u), I = f(() => {
    v(r <= 1 ? m : r - 1);
  }, [r, m]), _ = f(() => {
    v(r >= m ? 1 : r + 1);
  }, [r, m]);
  if (a.isNil(c))
    return null;
  const G = `${p("vip.level.count", {
    count: c.level
  })} - ${c.title}`, R = `${p("vip.level.require", {
    point: O(((b = h == null ? void 0 : h.vipLevel.levelChart[r - 1]) == null ? void 0 : b.minOrderlyPoint) || 0)
  })}`;
  return /* @__PURE__ */ o(Z, {
    children: [/* @__PURE__ */ o(ee, {
      children: [/* @__PURE__ */ i(te, {
        src: X
      }), /* @__PURE__ */ o(ie, {
        children: [/* @__PURE__ */ i(be, {
          onClick: I,
          children: /* @__PURE__ */ i(y, {})
        }), /* @__PURE__ */ o(ne, {
          children: [G, /* @__PURE__ */ o(oe, {
            as: "span",
            children: ["(", R, ")"]
          })]
        }), /* @__PURE__ */ i(we, {
          onClick: _,
          children: /* @__PURE__ */ i(y, {})
        })]
      })]
    }), /* @__PURE__ */ i(re, {
      children: /* @__PURE__ */ i(ae, {
        children: a.map((s) => {
          const w = a.length(s.permissions) > Y;
          return /* @__PURE__ */ o(se, {
            __isExpanded: !w || d,
            children: [/* @__PURE__ */ i(le, {
              children: /* @__PURE__ */ i(pe, {
                disabled: a.isEmpty(s.url),
                target: "_blank",
                url: s.url,
                children: /* @__PURE__ */ i(de, {
                  children: /* @__PURE__ */ i(W, {
                    children: p(s.name)
                  })
                })
              })
            }), /* @__PURE__ */ i(ce, {
              children: a.map((j) => {
                const {
                  description: H,
                  different: k,
                  id: x,
                  isNew: P,
                  name: M,
                  value: D
                } = j;
                return /* @__PURE__ */ o(me, {
                  "data-tooltip-id": x,
                  children: [P ? /* @__PURE__ */ i(he, {
                    children: /* @__PURE__ */ i(xe, {
                      src: J
                    })
                  }) : /* @__PURE__ */ i(fe, {}), a.isNotEmpty(k) && !P && /* @__PURE__ */ i(ue, {
                    as: "span",
                    children: k
                  }), /* @__PURE__ */ o(ge, {
                    children: [M, /* @__PURE__ */ i(ve, {
                      as: "span",
                      children: D
                    })]
                  }), /* @__PURE__ */ i(V, {
                    id: x,
                    children: H
                  })]
                }, x);
              }, s.permissions)
            }), w && /* @__PURE__ */ i(ke, {
              onClick: T,
              children: d ? /* @__PURE__ */ o(B, {
                children: [p("common.button.collapse"), /* @__PURE__ */ i(q, {})]
              }) : /* @__PURE__ */ o(B, {
                children: [p("common.more"), /* @__PURE__ */ i(F, {})]
              })
            })]
          }, s.name);
        }, c.groups)
      })
    })]
  });
};
export {
  He as default
};
//# sourceMappingURL=LevelPrivileges.js.map
